import {XauditModel} from '../xaudit.model';

export class DeviceConfigurationModel extends XauditModel {
  DeviceID: string;
  LOCID: number;
  Name: string;
  enumDeviceTypeID: string = '';
  enumDeviceTWAINID: string = '';
  enumDeviceSBID: string = '';
  ParametersJSON: string;
  CalibrationJSON: string;
}

